import React from 'react';
import { css } from 'emotion';
import { Footer } from 'client/components/Footer';
import {
  Header,
  BrandPartners,
  Carousel,
  FAQ,
  Glossary,
  Quote,
  SellingPoints,
  Video,
} from 'client/screens/AdsByAnchorScreen/components';
import { MarketingHeaderBackground } from 'client/components/MarketingPagesShared/MarketingHeaderBackground';
import { COLOR_GREEN } from 'client/components/MarketingPagesShared/styles';
import { PODCAST_COLORS } from 'client/utils';
import { hexToRgb, rgbToRgbaString } from 'client/modules/ColorUtils';

const headerColor = rgbToRgbaString(hexToRgb(COLOR_GREEN)!);

export function AdsByAnchorScreen() {
  return (
    <>
      <MarketingHeaderBackground color={headerColor} />
      <main
        className={css`
          background-color: ${PODCAST_COLORS.WHITE.color};
        `}
      >
        <Header />
        <section
          className={css`
            padding: 0 24px 132px;
            text-align: center;
          `}
        >
          <SellingPoints />
        </section>
        <Video />
        <Carousel />
        <Quote />
        <section
          className={css`
            background-color: ${COLOR_GREEN};
            padding: 0 24px;
          `}
        >
          <BrandPartners />
        </section>
        <section
          className={css`
            padding: 150px 24px;
          `}
        >
          <FAQ />
        </section>
        <section
          className={css`
            background-color: ${COLOR_GREEN};
            color: #fff;
            padding: 132px 24px;
          `}
        >
          <Glossary />
        </section>
      </main>
      <Footer />
    </>
  );
}
